// extracted by mini-css-extract-plugin
export default {"text":"Headlines_text__cSqix","number":"Headlines_number__stf8G"};